import { gql } from '@apollo/client';

export const UNDISPATCH_SCAN_ID = gql`
    mutation UndispatchGoods($data: DispatchUndispatchedInput!) {
        undispatchGoods(data: $data) {
            code
            success
            message
        }
    }`;

export default UNDISPATCH_SCAN_ID;
